// What every member page reads from the workspace store, and the "set up first" redirect.
import { capText, planLabel as labelOf } from '../lib/plans';
import { toast } from '../lib/toast';

export default {
  computed: {
    ws() { return this.$store.getters['praiseboard/data']; },
    brand() { return this.$store.getters['praiseboard/brand']; },
    brandId() { return this.$store.getters['praiseboard/brandId']; },
    brands() { return this.$store.getters['praiseboard/activeBrands']; },
    plan() { return this.$store.getters['praiseboard/plan']; },
    planLabel() { return (this.ws && this.ws.plan_label) || 'Free'; },
    limits() { return this.$store.getters['praiseboard/limits']; },
    usage() { return this.$store.getters['praiseboard/usage']; },
    isOwner() { return this.$store.getters['praiseboard/isOwner']; },
    // A teammate limited to some brands: `usage` covers those brands only, so no workspace-wide capacity is shown.
    scopedToBrands() { return this.$store.getters['praiseboard/scoped']; },
    multiBrand() { return this.brands.length > 1; },
    planMatrix() { return this.$store.getters['praiseboard/planMatrix']; }
  },
  methods: {
    can(capability) { return this.$store.getters['praiseboard/can'](capability); },
    // The plan that allows more of a policy.LIMITS key than the workspace's (null when none does), and its name.
    availableOn(key) { return this.$store.getters['praiseboard/availableOn'](key); },
    planName(name) { return labelOf(this.planMatrix, name); },
    // "1 of 1 on Free" once `used` fills the plan's cap for `key` and a higher plan allows more; '' otherwise.
    capOf(key, used) {
      const allowed = this.limits[key];
      if (typeof allowed !== 'number' || (used || 0) < allowed || !this.availableOn(key)) return '';
      return capText(used || 0, allowed, this.planLabel);
    },
    // Resolves the workspace; without one (or without a brand) the member is sent to /start.
    async requireWorkspace() {
      let data;
      try {
        data = await this.$store.dispatch('praiseboard/ensure');
      } catch (error) {
        toast(this.$store.getters['praiseboard/loadError'] || 'We couldn\'t load your workspace. Check your connection and try again.', 'error');
        return null;
      }
      if (!data || !data.workspace || !(data.brands || []).length) {
        this.$router.replace('/start').catch(() => {});
        return null;
      }
      return data;
    },
    refreshWorkspace() { return this.$store.dispatch('praiseboard/load').catch(() => null); }
  }
};
